import React, { useState, useEffect, useRef } from 'react'
import NavbarReturn from '../components/NavbarReturn';
import SearchBar from "../components/SearchBar";
import AlertBox from '../components/AlertBox';
import FooterAdmin from '../components/FooterAdmin';
import AlertOnLoading from '../components/AlertOnLoading';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import { v4 } from 'uuid';
import { Toaster } from 'react-hot-toast';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, getDocs, setDoc, doc, deleteDoc, query, where } from "firebase/firestore";
import { database, storage } from "../config/firebaseConfig";
import Select from 'react-select';
import {IoLogoWhatsapp} from 'react-icons/io';
import {MdEmail} from 'react-icons/md'

function ResultsAdmin() {
    const WAIT_TIME = 2000;
    const notInitialRender = useRef(false);

    const SUCCESS = "success"
    const WARNING = "warning"
    const DANGER = "danger"

    const [newData, setNewData] = useState(true); //it functions to validate if it needs to re-render
    const fileCollectionRef = collection(database, "results");

    const getMaxProducts = (width) => {
        if (width>= 640) {
          return 10;
        }
    
        return 5;
      }
  

    const [currentPage, setCurrentPage] = useState(1);
    const [resultsPerPages, setResultsPerPages] = useState(getMaxProducts(window.innerWidth));

    const [uploading, setUploading] = useState(false);

    const [sendWhatsapp, setSendWhatsapp] = useState(false);
    const [sendEmail, setSendEmail] = useState(false);

    const [resultName, setResultName] = useState("");

    const [fileSelected, setFileSelected] = useState("Resultado");
    const [fileUpload, setFileUpload] = useState(null);

    const [results, setResults] = useState(null);

    const [users, setUsers] = useState(null);

    const [selected, setSelected] = useState("");

    const lastResultIndex = currentPage * resultsPerPages;
    const firstResultIndex = lastResultIndex - resultsPerPages;

    const togglePopupDelete = (resultId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${resultId}`),function(itm){
          itm.style.display = "flex";
        })();
    }
  
    const closePopupDelete = (resultId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${resultId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    /*
        It customizes the No Option Message Drop Down
    */
    const customNoOptionMessage = () => {
        return "Sin Opciones"
    }

    /*
        It customizes the multi-select drop down for web
    */
    const customDropDown = {
        control: (styles) => ({...styles, 
            backgroundColor:'#E3EAF9',
            height:'32px',
            border:'none',
            borderRadius: '0',
            cursor: 'pointer'
        }),
        option: (styles, {isSelected}) => {
            return {...styles,
                color: isSelected? "#fff" : "#9ca3af",
                backgroundColor: isSelected? "#3B8EED" : "#E3EAF9", 
                ':hover' : {
                    backgroundColor: '#97C5F9',
                    color: 'white'
                },
                ':before' : {
                    backgroundColor: '#3B8EED',
                    color: 'white'
                }
            };
        },
        valueContainer: (styles) => ({
            ...styles,
            fontSize: '16px',
            lineHeight: '24px',
            overflow: 'hidden'
        }),
        singleValue: (styles) => ({
            ...styles,
            color: "#6B7280"
        }),
        indicatorSeparator: (styles) => ({
            ...styles,
            color: '#9ca3af'
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#3B8EED',
            color: 'white',
            borderRadius: '10px'
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: 'white'
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: 'white',
            ':hover' : {
                backgroundColor: '#97C5F9',
                color: 'black',
                borderRadius: '0px 10px 10px 0px'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#9ca3af'
        }),
        input: (styles) => ({
            ...styles,
            color: "#6B7280",
            height: '32px'
        }),
        menu: (styles) => ({
            ...styles,
            maxHeight: '80px',
            height: 'auto',
            background: '#E3EAF9',
            border:'none',
            borderRadius: '0',
            fontSize: '16px',
            lineHeight: '24px',
            color: '#6B7280'
        }),
        menuList: (styles) => ({
            ...styles,
            background: '#E3EAF9',
            border:'none',
            borderRadius: '0',
            overflowY: 'auto',
            height: 'auto',
            maxHeight: '80px'
        }),
        placeholder: (styles) => ({...styles,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#9ca3af'
        })
    }

    /*
        It customizes the multi-select drop down for web
    */
        const customDropDownMobile = {
            control: (styles) => ({...styles, 
                backgroundColor:'#E3EAF9',
                height:'32px',
                border:'none',
                borderRadius: '0',
                cursor: 'pointer'
            }),
            option: (styles, {isSelected}) => {
                return {...styles,
                    color: isSelected? "#fff" : "#9ca3af",
                    backgroundColor: isSelected? "#3B8EED" : "#E3EAF9", 
                    ':hover' : {
                        backgroundColor: '#97C5F9',
                        color: 'white'
                    },
                    ':before' : {
                        backgroundColor: '#3B8EED',
                        color: 'white'
                    }
                };
            },
            valueContainer: (styles) => ({
                ...styles,
                fontSize: '16px',
                lineHeight: '24px',
                overflow: 'hidden'
            }),
            singleValue: (styles) => ({
                ...styles,
                color: "#6B7280"
            }),
            indicatorSeparator: (styles) => ({
                ...styles,
                color: '#9ca3af'
            }),
            multiValue: (styles) => ({
                ...styles,
                backgroundColor: '#3B8EED',
                color: 'white',
                borderRadius: '10px'
            }),
            multiValueLabel: (styles) => ({
                ...styles,
                color: 'white'
            }),
            multiValueRemove: (styles) => ({
                ...styles,
                color: 'white',
                ':hover' : {
                    backgroundColor: '#97C5F9',
                    color: 'black',
                    borderRadius: '0px 10px 10px 0px'
                }
            }),
            dropdownIndicator: (styles) => ({
                ...styles,
                color: '#9ca3af'
            }),
            input: (styles) => ({
                ...styles,
                color: "#6B7280",
                height: '32px'
            }),
            menu: (styles) => ({
                ...styles,
                maxHeight: '80px',
                height: 'auto',
                background: '#E3EAF9',
                border:'none',
                borderRadius: '0',
                fontSize: '16px',
                lineHeight: '24px',
                color: '#6B7280'
            }),
            menuList: (styles) => ({
                ...styles,
                background: '#E3EAF9',
                border:'none',
                borderRadius: '0',
                overflowY: 'auto',
                height: 'auto',
                maxHeight: '80px'
            }),
            placeholder: (styles) => ({...styles,
                fontSize: '14px',
                lineHeight: '20px',
                color: '#9ca3af'
            })
        }

    /* 
        Add the reason selected to selected
    */
    function handleChange(selectedUser) {
        console.log(selectedUser);
        setSelected(selectedUser);
    }

    /*
        Get current date as "DD/MM/YYYY"
    */
    function getCurrentDate() {
        const current = new Date();
        const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
        return date;
    }

    function updateText(event) {
        setFileUpload(event.target.files[0]);
        const newText = document.getElementById("uploadFile").value;
        const getFileName = newText.split("\\");
        setFileSelected(getFileName[getFileName.length - 1]);
    }

    function openResult(resultURL) {
        window.open(resultURL);
    }

    /*
        Creates a new result document on firebase
    */
    async function createResult() {
        if (selected === "") {
            AlertBox(WARNING, '¡Debe escoger un número de cédula!')
            return;

        } else if (resultName === "") {
            AlertBox(WARNING, '¡Debe indicar un motivo para la inserción!');
            return;

        } else if (fileUpload == null) {
            AlertBox(WARNING, '¡Debe seleccionar un archivo como resultado!');
            return;

        } else {

            const addButton = document.querySelectorAll("#addRegister");
            addButton[0].setAttribute("disabled", true);

            setUploading(true);

            const fileRef = await ref(storage, `files/${fileUpload.name + v4()}`);

            uploadBytes(fileRef, fileUpload).then(async () => {

                if (sendWhatsapp) {
                    if (!selected.value.phone){
                        alert("El usuario no tiene un número de teléfono registrado");

                        addButton[0].removeAttribute("disabled");

                        setUploading(false);
                        return;
                    }

                    window.open(
                        `https://wa.me/${selected.value.phone}?text=Hola!%20${selected.value.name}%20`, "_blank");
                }


                const fileURL = await getDownloadURL(fileRef);
                const resultsRef = collection(database, 'users', selected.value.id, 'results');
                const newFileRef = doc(fileCollectionRef);
                const date = getCurrentDate();

                await setDoc(newFileRef, {client_id: selected.label, name:resultName, file:fileURL, user_id: selected.value.id, creation_date:date, client_phone:selected.value.phone});

                if (window.Email && sendEmail) {
                    window.Email.send({
                        Host : "smtp.elasticemail.com",
                        Username : "innovida20@gmail.com",
                        Password : "86994EEBA4A2458CEA189BA53698034C12A4",
                        Port : 2525,
                        To : "kzumbado23@gmail.com",
                        From : "innovida20@gmail.com",
                        Subject : "Resultados Laboratorio Santa Bárbara",
                        Body : `Hola ${selected.value.name} \nTe informamos que los resultados del Laboratorio Clínico Santa Bárbara ya están disponibles\nLos puedes encontrar en la plataforma y adjunto en este correo`,
                        Attachments : [
                        {
                            name : "resultados.pdf",
                            path : fileURL
                        }]
                    }).then(
                      message => alert("Correo Enviado")
                    );
                }
               
                const userResultRef = doc(resultsRef, newFileRef.id);
                console.log(userResultRef);
                await setDoc(userResultRef, {
                        client_id: selected.label,
                        name:resultName,
                        file:fileURL,
                        creation_date:date,
                        client_phone: selected.value.phone
                    });

                setFileSelected("Resultado");
                setResultName("");
                setSelected("");
                setFileUpload(null);
                setNewData(true);
                setSendEmail(false);
                setSendWhatsapp(false);
                addButton[0].removeAttribute("disabled");

                setUploading(false);

                AlertBox(SUCCESS, 'Resultado agregado exitosamente');
                return;
            })
            .catch(error => {
                console.log("Error al subir el documento ", error);
                addButton[0].removeAttribute("disabled");

                setUploading(false);
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                return;
            });

            return;
        }
    }

    /*
        Deletes a result document
    */
    async function deleteResult(resultId) {
        const resultDoc = doc(database, "results", resultId);
        
        results?.filter((result) => (
            result.id?.includes(resultId)
        )).map(async (result) => {
            if (result.user_id) {
                const userResultDoc = doc(database, "users", result.user_id, "results", resultId);
                await deleteDoc(userResultDoc);
            }
        })
        
        await deleteDoc(resultDoc);

        setNewData(true);
        closePopupDelete(resultId);
        AlertBox(SUCCESS, '¡Resultado eliminado correctamente!');
    }

    /*
        Loads the DropDown of categories 
    */
    useEffect(() => {
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const usersCollectionRef = collection(database, "users");
                const getUsers = async() => {
                    const userQuery = query(usersCollectionRef, where("role", "==", "user"));
                    const data = await getDocs(userQuery);
                    setUsers(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                
                getUsers();
                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [users, newData])

    useEffect(() => {
        if (notInitialRender.current && newData){
            AlertOnLoading(WAIT_TIME+100);
        }else {
            notInitialRender.current = true;
        }
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const resultsRef = collection(database, "results");
                
                const getResults = async() => {
                    const data = await getDocs(resultsRef);
                    setResults(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                getResults();
                setNewData(!newData);
                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
      }, [results, newData])

    const resizeProducts = () => {
    setResultsPerPages(getMaxProducts(window.innerWidth));
    return;
    }

    window.addEventListener("resize", resizeProducts)
  return (
    <div>
        <div>
        <Toaster
        toastOptions={{
            duration:3000,
        }}/>

        </div>

        <NavbarReturn />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>

        <div className='min-h-screen bg-white'>
            <div className='lg:px-8 px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
                <h2 className='lg:text-xl'>Enviar un Resultado</h2>
                <span className='lg:w-96 w-56 border border-primary-100'></span>
            </div>
            
            <div className='lg:px-8 px-4 py-0 w-full h-auto flex flex-row bg-white'>

                <div className='flex flex-col space-y-5 px-4 py-6'>

                    <Select className='hidden w-full h-input-height text-sm md:text-base focus:outline-none focus:border focus:border-primary-100 focus:shadow-md md:block'
                        noOptionsMessage={customNoOptionMessage}
                        placeholder="Cédula" 
                        options={users?.map((user) => ({value:{email: user.email, id: user.id, name: `${user.name} ${user.lastname}`, phone: user.phone}, label:user.client_id}))}
                        value={selected === ""? "":{value:selected.value, label:selected.label}}
                        onChange={handleChange}
                        styles={customDropDown}
                    />

                    <Select className='w-full h-input-height text-sm md:text-base focus:outline-none focus:border focus:border-primary-100 focus:shadow-md md:hidden'
                        noOptionsMessage={customNoOptionMessage}
                        placeholder="Cédula" 
                        options={users?.map((user) => ({value:{email: user.email, id: user.id, name: `${user.name} ${user.lastname}`, phone: user.phone}, label:user.client_id}))}
                        value={selected === ""? "":{value:selected.value, label:selected.label}}
                        onChange={handleChange}
                        styles={customDropDownMobile}
                    />

                    <div>
                        <input onChange={(event) => {setResultName(event.target.value)}} value={resultName} type={"text"} placeholder="Motivo"
                            className='text-sm md:text-base w-full sm:w-64 md:w-96 h-input-height px-3 text-input-font bg-primary-300
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                    </div>

                    <div>
                        <div className='relative h-input-height w-full sm:w-64 md:w-96 py-2 pl-3 pr-8 overflow-hidden
                            text-input-font bg-primary-300 focus:outline-none 
                            focus:border focus:border-primary-100 focus:shadow-md min-w-max'>
                            <div className='w-48 sm:w-52 md:w-60 lg:w-80 overflow-hidden'>
                                <label htmlFor="file" id="fileName" className={`${fileSelected==="Resultado"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{fileSelected}</label>
                            </div>
                            

                            <div className='absolute inset-y-0 right-0 flex items-center'>
                                <ArrowUpTrayIcon className={`${fileSelected==="Resultado"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                            </div>

                            <input onChange={updateText} id="uploadFile" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-input-height' 
                            aria-hidden='true' type={"file"} accept=".pdf"/>
                        </div>
                    </div>

                    <div className='mt-1'>
                        <div className=' flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2'>
                            <div className={`bg-white shadow-lg w-full py-2 px-2 rounded-lg flex justify-between items-center border-t-2 ${sendWhatsapp? "border-primary-100": "border-placeholder"}`}>
                                <div className='flex items-center'>
                                    <IoLogoWhatsapp className='w-6 h-6 md:w-8 md:h-8 text-green-500' />
                                    <div className='ml-2 text-sm md:text-base'>
                                        Whatsapp
                                    </div>
                                </div>

                                <label htmlFor="toggleTwo" className="flex cursor-pointer select-none items-center">
                                    <div className="relative ml-4" onClick={()=>{setSendWhatsapp(!sendWhatsapp)}}>
                                        <div className="block h-5 w-9 md:h-6 md:w-10 rounded-full bg-[#E5E7EB]"></div>
                                        <div
                                        className={`dot absolute ${!sendWhatsapp? "left-1 top-1 bg-white" : "right-1 top-1 bg-primary-100"} h-3 w-3 md:h-4 md:w-4 rounded-full  transition`}
                                        ></div>
                                    </div>
                                </label>

                            </div>

                            <div className={`bg-white shadow-lg w-full py-2 px-2 rounded-lg flex justify-between items-center border-t-2 ${sendEmail? "border-primary-100": "border-placeholder"}`}>
                                <div className='flex items-center'>
                                    <MdEmail className='w-6 h-6 md:w-8 md:h-8 text-gray-500' />
                                    <div className='ml-2 text-sm md:text-base'>
                                        E-mail
                                    </div>
                                </div>

                                <label htmlFor="toggleTwo" className="flex cursor-pointer select-none items-center">
                                    <div className="relative ml-4" onClick={()=>{setSendEmail(!sendEmail)}}>
                                        <div className="block h-5 w-9 md:h-6 md:w-10 rounded-full bg-[#E5E7EB]"></div>
                                        <div
                                        className={`dot absolute ${!sendEmail? "left-1 top-1 bg-white" : "right-1 top-1 bg-primary-100"} h-3 w-3 md:h-4 md:w-4 rounded-full  transition`}
                                        ></div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button id="addRegister"
                            className='hover:bg-primary-200 h-8 w-full sm:w-64 md:w-96 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold form1:text-xl disabled:bg-primary-200'
                            onClick={createResult}>
                            {!uploading? 
                            "Enviar"
                            : 
                            <div className="w-full flex justify-center items-center"> 
                                <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                <path clipRule='evenodd'
                                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                    fill='currentColor' fillRule='evenodd' />
                                </svg> 
                                Enviando
                            </div>}
                        </button>
                    </div>

                </div>

            </div>

            
            
            <div className='lg:px-8 px-4 flex flex-col w-full h-full bg-white'>
                <h2 className='lg:text-xl mt-10'>Todos los Resultados</h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>
                <div className={`${results?.length? "block mt-8":"hidden"}`}>
                    <SearchBar options={["Antiguos", "Recientes"]} allDocs={''}/>
                </div>
            </div>

            <div className=''>
                <div className="sm:flex sm:flex-col sm:px-10 sm:w-full sm:justify-center sm:items-center bg-white py-6">

                    <div className={`sm:flex sm:flex-col sm:w-full sm:space-y-1 sm:justify-center ${results?.length? "sm:border sm:border-primary-100": "border-none"} p-1 sm:max-w-table-web`}>

                            <div className={`${results?.length? "hidden w-full sm:flex flex-row space-x-1":"hidden" }`}>
                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Cédula</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Teléfono</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Motivo</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Fecha</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Acción</h3>
                                </div>
                            </div>

                        {results? results.slice(firstResultIndex, lastResultIndex).map((result, index)=> (
                        <div key={index}>
                            <div className="hidden w-full sm:flex flex-row space-x-1">

                                <div className="flex justify-center items-center w-full h-8 bg-background">
                                    <h3 className="text-sm text-navFont-100 md:text-sm lg:text-xl form1:text-xl">{result.client_id}</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-background">
                                    <h3 className="text-sm text-navFont-100 md:text-sm lg:text-xl form1:text-xl">{result.client_phone}</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-background">
                                    <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{result.name}</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-background">
                                    <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{result.creation_date}</h3>
                                </div>

                                <div className="space-x-0.5 flex justify-center items-center w-full h-8 bg-background">

                                    <div className='w-full h-9 flex justify-center items-center'>
                                        <button onClick={() => {openResult(result.file);}} className='w-full h-7 text-sm bg-primary-100 text-white rounded-md font-bold lg:text-sm form1:text-xl hover:bg-primary-200'>Resultado</button>
                                    </div>

                                    <div className='w-full h-9 flex justify-center items-center'>
                                        <button onClick={() => {togglePopupDelete(result.id);}} className='w-full h-7 text-sm bg-danger text-white rounded-md font-bold lg:text-sm form1:text-xl hover:bg-red-400'>Eliminar</button>
                                    </div>

                                </div>

                            </div>

                            <div className="w-full mb-4 flex justify-center sm:hidden sm:w-auto sm:flex-col sm:border sm:border-primary-100 sm:max-w-table-web sm:justify-center form1:mx-80 lg:justify-center lg:mx-56 lg:max-w-table-web">
                                
                                <div className="flex flex-col space-y-1 border border-primary-100 p-1 justify-center w-4/5 h-auto sm:flex-row sm:space-y-0 sm:space-x-1 sm:w-full max-w-table-web sm:border-none">
                                    
                                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                        <h3 className="text-sm text-primary-100">Cédula</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                                        <h3 className="text-sm text-navFont-100">{result.client_id}</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                        <h3 className="text-sm text-primary-100">Teléfono</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                                        <h3 className="text-sm text-navFont-100">{result.client_phone}</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                        <h3 className="text-sm text-primary-100">Motivo</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                                        <h3 className="text-sm text-navFont-100">{result.name}</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                        <h3 className="text-sm text-primary-100">Fecha</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                                        <h3 className="text-sm text-navFont-100">{result.creation_date}</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                        <h3 className="text-sm text-primary-100">Acción</h3>
                                    </div>

                                    <div className='sm:hidden space-x-2 w-full h-8 flex justify-center items-center bg-background'>
                                        
                                        <div className='w-1/2 h-9 flex justify-center items-center'>
                                            <button onClick={() => {openResult(result.file);}} className='w-full h-7 text-sm bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Resultado</button>
                                        </div>

                                        <div className='w-1/2 h-9 flex justify-center items-center'>
                                            <button onClick={() => {togglePopupDelete(result.id);}} className='w-full h-7 text-sm bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar</button>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className={`hidden relative z-40 popup_delete ${result.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                                <div className="fixed inset-0 bg-popup"></div>

                                <div className="fixed inset-0 z-10 overflow-y-auto">
                                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                            <div className="sm:flex sm:items-start">
                                            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                                </svg>
                                            </div>
                                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                                <div className="mt-2">
                                                <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button onClick={() => {deleteResult(result.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                            <button onClick={() => {closePopupDelete(result.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        ))
                        :
                        <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                            <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                <path clipRule='evenodd'
                                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                    fill='currentColor' fillRule='evenodd' />
                            </svg>
                            <div>
                                Cargando...
                            </div>
                        </div>
                        }
                    </div>
                    
                    <div className={`${results?.length? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                        <span className={`text-sm text-gray-700`}>
                            Mostrando <span className="font-semibold text-gray-900">{lastResultIndex >= results?.length? results?.length:lastResultIndex}</span> de <span className="font-semibold text-gray-900">{results?.length}</span> resultados
                        </span>
                        <div className="inline-flex mt-2 xs:mt-0">
                            <button
                                onClick={() => {setCurrentPage(currentPage - 1)}} 
                                className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                                Anterior
                            </button>
                            <button 
                                onClick={() => {setCurrentPage(currentPage + 1)}}
                                
                                className={`${lastResultIndex >= results?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                                Siguiente
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        
        <FooterAdmin />
    </div>
  )
}

export default ResultsAdmin